<template>
  <div class="results-page min-h-[100vh]">
    <ResultsWrapper />
  </div>
</template>

<script>
import ResultsWrapper from '@/wrappers/ResultsWrapper.vue';

export default {
  name: "ResultsPage",
  components: {
    ResultsWrapper,
  },
};
</script>